interface ExportMotionIconProps {
  className?: string;
  exporting?: boolean;
}

export default function ExportMotionIcon({
  className,
  exporting = false,
}: ExportMotionIconProps) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 12V17.3333C18 17.5101 17.9298 17.6797 17.8047 17.8047C17.6797 17.9298 17.5101 18 17.3333 18H2.66667C2.48986 18 2.32029 17.9298 2.19526 17.8047C2.07024 17.6797 2 17.5101 2 17.3333V12C2 11.8232 2.07024 11.6536 2.19526 11.5286C2.32029 11.4036 2.48986 11.3333 2.66667 11.3333C2.84348 11.3333 3.01305 11.4036 3.13807 11.5286C3.2631 11.6536 3.33333 11.8232 3.33333 12V16.6667H16.6667V12C16.6667 11.8232 16.7369 11.6536 16.8619 11.5286C16.987 11.4036 17.1565 11.3333 17.3333 11.3333C17.5101 11.3333 17.6797 11.4036 17.8047 11.5286C17.9298 11.6536 18 11.8232 18 12Z"
        fill="currentColor"
      />
      <g>
        {exporting ? (
          <animateTransform
            attributeName="transform"
            type="translate"
            values="0 -1.25;0 1.25;0 -1.25"
            dur="0.9s"
            repeatCount="indefinite"
            calcMode="spline"
            keySplines="0.45 0 0.55 1;0.45 0 0.55 1"
          />
        ) : null}
        <path
          d="M9.52833 12.4717C9.59025 12.5337 9.66377 12.5828 9.74471 12.6164C9.82564 12.6499 9.91239 12.6672 10 12.6672C10.0876 12.6672 10.1744 12.6499 10.2553 12.6164C10.3362 12.5828 10.4098 12.5337 10.4717 12.4717L13.805 9.13833C13.8669 9.07639 13.9161 9.00286 13.9496 8.92193C13.9831 8.841 14.0004 8.75426 14.0004 8.66667C14.0004 8.57907 13.9831 8.49233 13.9496 8.4114C13.9161 8.33047 13.8669 8.25694 13.805 8.195C13.7431 8.13306 13.6695 8.08393 13.5886 8.0504C13.5077 8.01688 13.4209 7.99963 13.3333 7.99963C13.2457 7.99963 13.159 8.01688 13.0781 8.0504C12.9971 8.08393 12.9236 8.13306 12.8617 8.195L10.6667 10.3908V2.66667C10.6667 2.48986 10.5964 2.32029 10.4714 2.19526C10.3464 2.07024 10.1768 2 10 2C9.82319 2 9.65362 2.07024 9.5286 2.19526C9.40357 2.32029 9.33333 2.48986 9.33333 2.66667V10.3908L7.13833 8.195C7.01324 8.06991 6.84358 7.99963 6.66667 7.99963C6.48976 7.99963 6.32009 8.06991 6.195 8.195C6.06991 8.32009 5.99963 8.48976 5.99963 8.66667C5.99963 8.84358 6.06991 9.01324 6.195 9.13833L9.52833 12.4717Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
